export default "__VITE_ASSET__Ur4yWFmT__"